import { permissionsService } from './permissionsService';
import { tokenService } from '../services/auth/tokenService';

export const modulePermissions = {
  hasPermission: (moduleName, permission) => {
    const permissions = permissionsService.getPermissionsByModule(moduleName);
    const result = permissions.filter(p => p.name === permission);
    return result.length > 0;
  },

  hasUserManagementPermission: (permission) => {
    return modulePermissions.hasPermission('user_management', permission);
  },

  hasGroupManagementPermission: (permission) => {
    return modulePermissions.hasPermission('group_management', permission);
  },

  hasClientManagementPermission: (permission) => {
    return modulePermissions.hasPermission('client_management', permission);
  },

  hasRolesPermission: (permission) => {
    return modulePermissions.hasPermission('roles_permissions_management', permission);
  },

  hasClientPersonalDataPermission: (permission) => {
    return modulePermissions.hasPermission('client_personal_data', permission);
  },

  hasClientTokenHistoryPermission: (permission) => {
    return modulePermissions.hasPermission('client_token_history', permission);
  },

  hasClientRequestHistoryPermission: (permission) => {
    return modulePermissions.hasPermission('client_request_history', permission);
  },

  hasClientReceivedServiceHistoryPermission: (permission) => {
    return modulePermissions.hasPermission('client_received_services_history', permission);
  },

  hasClientSupportPermission: (permission) => {
    return modulePermissions.hasPermission('client_support', permission);
  },

  hasClientGroupsPermission: (permission) => {
    return modulePermissions.hasPermission('client_groups', permission);
  },

  hasGroupsPermission: (permission) => {
    return modulePermissions.hasPermission('group_management', permission);
  },

  hasClientTabPermission: () => {
    const permissionData = modulePermissions.hasPermission('client_personal_data', 'view');
    const permissionToken = modulePermissions.hasPermission('client_token_history', 'view');
    const permissionRequest = modulePermissions.hasPermission('client_request_history', 'view');
    const permissionService = modulePermissions.hasPermission('client_received_services_history', 'view');
    const permissionSupport = modulePermissions.hasPermission('client_support', 'view');
    const permissionGroups = modulePermissions.hasPermission('client_groups', 'view');
    return permissionData || permissionToken || permissionRequest || permissionService || permissionSupport || permissionGroups;
  },

  hasTokenManagementPermission: (permission) => {
    return modulePermissions.hasPermission('token_management', permission);
  },

  hasSupportManagementPermission: (permission) => {
    return modulePermissions.hasPermission('support_management', permission);
  },

  clearPermissions: () => {
    permissionsService.clearPermissions();
    tokenService.clearTokens();
  }
};
